{
  "ANY": "any_schedule",
  "GLOBAL": "global_schedule",
  "MEMBER": "member_schedule",
  "OWN": "own_schedule"
}
